import { render, staticRenderFns } from "./CamposSecao.vue?vue&type=template&id=7935a800&"
import script from "./CamposSecao.vue?vue&type=script&lang=js&"
export * from "./CamposSecao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports